import { render } from "./loader-opportunities.vue?vue&type=template&id=2d239b9a&ts=true"
import script from "./loader-opportunities.vue?vue&type=script&lang=ts"
export * from "./loader-opportunities.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__